// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'layout-connected';

export const Component = () => (
  <g fill='none' stroke='#4185DE' strokeLinecap='round' strokeLinejoin='round'>
    <rect width='17' height='17' x='.5' y='.5' fill='#D0E0F7' rx='1.5' />
    <path d='M0 4.5h17M4 5v12' />
  </g>
);

export const viewBox = '0 0 18 18';
